// extracted by mini-css-extract-plugin
export default {"svg-container":"_-paper-src-___icon__svg-container___wrKGI"};